import { Injectable } from '@angular/core';
import { IIssueType } from '@common/interfaces/issueType';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { IssueTypeQuery } from './issueType.query';
import { IssueTypeStore } from './issueType.store';

@Injectable({
  providedIn: 'root'
})
export class IssueTypeService extends CrudService<IIssueType, IssueTypeStore, IssueTypeQuery>{

  constructor(
    protected store: IssueTypeStore,
    public query: IssueTypeQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.ISSUE_TYPES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
